import { Pedido } from '@/models/pedido'

interface InclusaoVeiculoForm{
  currentStep: number;
  isLoading: boolean;
  data: Pedido;
  documentos: Array<any>;
  error: any;
}

export const initialStateInclusaoVeiculoForm: InclusaoVeiculoForm = {
  currentStep: 1,
  isLoading: false,
  data: null,
  documentos: [],
  error: null,
}

export default {
  form: initialStateInclusaoVeiculoForm
}
